/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data ids used in the environment variable component sets screen.
 * @export
 */
export const ENVIRONMENT_VARIABLE_DATA_IDS = {
  cancel: `env-var-cancel`,
  cancelNew: `env-var-cancel-new`,
  cancelNewVariable: `new-env-var-cancel`,
  delete: 'env-var-delete',
  save: `env-var-save`,
};

/**
 * The form field ids used in the environment variable component sets screen.
 * @export
 */
export const ENVIRONMENT_VARIABLE_FORM_IDS = {
  form: 'ev-var-form',
  new: 'new-env-var',
  value: 'env-var-value',
};
